<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" >添加库存</el-button>
      </el-col>
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="eitSotck" style="width: 100%" >批量编辑库存</el-button>

      </el-col>
      <el-col :span="3">
        <el-input placeholder="商品名称" v-model="params.goods_name" style="width: 100%">
<!--          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>-->
        </el-input>
      </el-col>
      <el-col :span="3">
        <el-input placeholder="门店ID" v-model="params.distribution_id" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
    </el-row>


    <el-table :data="tagsList" :height="wheight-130" v-loading="loading"  @selection-change="handleSelectionChange" :row-key="getRowKey">
      <el-table-column type="selection" :reserve-selection="true" v-model="checked" align="center" label="全选" ></el-table-column>
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="stock" label="库存量" width="200" >
        <template slot-scope="scope">
          {{scope.row.stock}}
      </template>
      </el-table-column>
      <el-table-column prop="name" label="商品名称" width="200" >
        <template slot-scope="scope">
          {{scope.row.name}}
        </template>
      </el-table-column>

      <el-table-column prop="distribution_ids" label="门店号" width="200" >
        <template slot-scope="scope">
          {{scope.row.distribution_id}}
        </template>
      </el-table-column>





      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>
            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>
<!--            <el-button type="text" @click="onSale(scope.$index, scope.row)">上架</el-button>-->
<!--            <el-button type="text" @click="onSale(scope.$index, scope.row)" >下架</el-button>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
     <el-pagination
     layout="prev, pager, next"
     @current-change="handleCurrentChange"
     :current-page.sync="params.page"
     :total="total_count" :page-size="params.pageSize">
     </el-pagination>
   </div>
   <el-dialog title="添加、编辑标签" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog">
     <template>
       <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
         <el-form-item class="content-left" label="商品">
           <template >
             <template>
               <el-select v-model="form.goods_id" placeholder="请选择"  >
                 <el-option
                   v-for="item in GoodsList"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
                 </el-option>
               </el-select>
             </template>
           </template>

         </el-form-item>
         <el-form-item class="content-left" label="库存量">

           <el-input placeholder="库存量" v-model="form.stock"></el-input>
         </el-form-item>

         <el-form-item class="content-left" label="门店编码">

           <el-input placeholder="门店编码" v-model="form.distribution_id"></el-input>
         </el-form-item>

         <!--店铺图片-->

         <el-form-item class="content-center">
           <el-button type="primary" @click="saveTagData">确定保存</el-button>
           <el-button type="button" @click="cancelData">取消</el-button>
         </el-form-item>
       </el-form>
     </template>

   </el-dialog>
    <el-dialog title="添加、编辑标签" width="40%" :visible.sync="stockDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
          <el-form-item class="content-left" label="库存量">
            <el-input placeholder="库存量" v-model="form.stock"></el-input>
          </el-form-item>

          <el-form-item class="content-center">
            <el-button type="primary" @click="saveStocks">确定保存</el-button>
            <el-button type="button" @click="cancelData">取消</el-button>
          </el-form-item>
        </el-form>
      </template>

    </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { delStock,createStock,getGoodList,updateStock,getStockList,saveStocks } from'../../../api/jianguan.js'
  import draggable from 'vuedraggable'

  import imgPicker from '@/components/imageselect'
  import {delGoods} from "../../../api/duiba";


  export default {
    components: {
      imgPicker,
      draggable,
    },
    data () {
      return {
        checked:'',
        storeImagesDialog: false,
        imgDialog: false,
        isGetImage: false,
        isEdit: false,
        GoodsList:[],
        cateGoryList:[],
        loading: false,
        total_count: 0,
        actionPath: 'https://up-z1.qiniup.com',
        image_prefix: '',
        multiple: false,
        type_detail_list:[{
          type_name:'',id:''
        }],
        category_id:'',
        detail_type:'',
        postData: {
          token: '',
          key: '',
          fname: ''
        },
        pics:'',
        tag: [
          {label: '普药', value: 0},
          {label: '慢病', value: 1},
          {label: '慢病+', value: 2},
          {label: '肿瘤', value: 3}
        ],
        dragIssuesOptions: {
          animation: 300,
          forceFallback: true,
          scroll: true,
          handle: '.icon-arrows-alt',
          draggable: '.goodspic'
        },
        id_arr:[],
        tagsList: [],
        params: {
          page: 1,
          pageSize: 20,

          goods_name:'',
          distribution_id:'',
        },
        form: {
          form:"",
          stock:"",
          goods_name:'',
          distribution_id:'',
        },
        currentSku2: -1,
        currentSku: -1,
        pickerImgType: 'logo',
        isGetStoreImages: false,
        memberTagDialog: false,
        stockDialog:false,
        predefineColors:['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585'],
        storeImagesCurrent: -1,
        storeImagesOldLen: 0,
        specImages: [],
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      type_change(e){

       this.radio = e;
       if (this.radio == "1") {

       } else if (this.radio=='2') {

       }else{

       }
     },
      handleSelectionChange(rows) {
        this.id_arr = []

        console.log('before'+this.id_arr )

        if (rows) {
          rows.forEach(row => {
            if (row) {
              this.id_arr.push(row.id)

            }
          })
        }

      },
      saveStocks(){
        // this.sotckDialog=true;


       // this.form.push(x);
// console.log(this.id_arr)
        this.form.form=JSON.stringify(this.id_arr)
        console.log(this.form)
        saveStocks(this.form).then(response =>{
          if (response.status==200) {

            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 5 * 1000
            })
            this.stockDialog = false
          } else {
            this.$message({
              type: 'error',
              message: '操作失败'
            })
          }
          this.getDataList()
        }).catch(() => {
          //    console.log(row.channelOrderNo)
          this.$message({
            type: 'error',
            message: '操作失败'
          })
        })
      },
      storeImagesLeave0() {
        console.log('storeImagesLeave0')
        this.storeImagesCurrent = -1
      },
      pickImg(data) {
        if (this.pickerImgType == 'logo') {
          this.form.logo = data.url
        } else {
          this.form.banner = data.url
        }
        this.imgDialog = false
      },

      pickStoreImages0(data) {
        console.log(this.form,"dsajj")
        if (this.currentSku2 === -1) {
          if (this.storeImagesOldLen + data.length >= 10) {
            this.$message.error('最多上传9张图片!')
            return false
          } else {
            if (data.length != 0) {
              data.map(data => {
                console.log(data.url)
                if (data && data.url !== '') {
                  this.form.banner_url.push(data.url)
                  this.storeImagesOldLen = this.form.banner_url.length
                }
              })
            }
          }
        } else {
          if (this.specImages[this.currentSku].item_image_url.length + data.length > 5) {
            this.$message.error('最多添加5张图片!')
            return false
          }
          if (data.length > 0) {
            data.forEach(data => {
              if (data && data.url !== '') {
                this.specImages[this.currentSku].item_image_url.push(data.url)
              }
            })
          }
          this.currentSku = -1
        }
        this.storeImagesDialog = false
        this.isGetStoreImages = false
      },
      closeStoreImagesDialog0() {
        console.log('close211')
        this.storeImagesDialog = false
        this.isGetStoreImages = false
      },
      removeStoreImages0: function (index) {
        this.form.banner_url.splice(index, 1)
        this.storeImagesOldLen = this.form.banner_url.length
      },
      handleStoreImagesChange0() {
        this.storeImagesDialog = true
        this.isGetStoreImages = true
        this.multiple = true
      },
      handleCurrentChange (page_num) {
        this.params.page = page_num

        this.getDataList()
      },
      addTemplate () { // 添加商品
        this.memberTagDialog = true
        // this.form = {id: '',product_name: '',tag: ''}
      },

      eitSotck(){
        //批量添加库存
        this. stockDialog=true
      },
      editAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      upAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      downAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      preview (index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      cancelData(){
        this.memberTagDialog = false;
        this.stockDialog=false;
        this.getDataList()
     //   this.$router.go(0)
      },
      getRowKey(row){
        return row.id;
      },
      getGoodList () {
        this.loading = true
        getGoodList(this.params).then(response => {
          this.GoodsList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      getDataList () {
        this.loading = true
        getStockList(this.params).then(response => {
          this.tagsList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })

      },

      deleteAction (index, row) {

        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          delStock(row.id).then(response => {

            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
            this.getDataList()
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      getTaskTime (strDate) {
          let date = new Date(strDate)
          let y = date.getFullYear()
          let m = date.getMonth() + 1
          m = m < 10 ? ('0' + m) : m
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let str = y+"-"+m+"-"+d
          return str
      },
      getTimeStr (date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog () {
  			this.memberTagDialog = false
        this.stockDialogstockDialog = false
      },
      saveTagData () {
        this.memberTagDialog = false
      //  this.form.pics= this.pics

// console.log(this.form.id)
        if (this.form.id!=undefined) {

          updateStock(this.form.id, this.form).then(res => {

            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '修改成功'
              })

            }
            this.getDataList()
          })
        } else {

          this.form.pics= this.pics
          createStock(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.getDataList()
            }
          })
        }

      },
      storeImagesEnter0(index) {
        console.log('storeImagesEnter0')
        this.storeImagesCurrent = index
      },
    },


    mounted () {

     this.getDataList()
    this.getGoodList()

// this.category_id= this.cateGoryList[0].id;
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// stock.vue?27617ddb